"use client";

import { cn } from "@/utils/cn";
import * as SeparatorPrimitive from "@radix-ui/react-separator";

import * as React from "react";

import { memo } from "react";

/**
 * Separator — shadcn primitive migrated to class-selector + co-located CSS.
 *
 * REFERENCE PATTERN: class-selector + co-located CSS (see shadcn-authoring.md
 * commit b35c0a615). Fourteenth execution of the shadcn-authoring template;
 * fourth Tier-4 primitive after Tooltip / Popover / Progress.
 *
 * Public API preserved EXACTLY: Radix integration verbatim; forwardRef +
 * displayName preserved; orientation default ("horizontal") + decorative
 * default (true) preserved.
 *
 * The orientation prop drives the variant via Radix's automatically-emitted
 * data-orientation attribute on the rendered DOM element. No manual
 * data-attribute injection needed — Radix sets the attribute. CSS reads
 * [data-orientation="horizontal" | "vertical"] for height/width swap.
 *
 * Source: docs/implementation-blueprint.md §8.3 (class-selector pattern);
 *         .claude/agent-prompts/shadcn-authoring.md (binding template, commit b35c0a615);
 *         src/components/ui/shadcn/skeleton.tsx (single-rule shadcn precedent, commit 4369425c4).
 */

const Separator = memo(
 React.forwardRef<React.ComponentRef<typeof SeparatorPrimitive.Root>, React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>>(({ className, orientation = "horizontal", decorative = true, ...props }, ref) => <SeparatorPrimitive.Root ref={ref} decorative={decorative} orientation={orientation} className={cn("dw-separator", className)} data-component="Separator" data-location="src/components/ui/shadcn/separator.tsx" {...props} />)
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
